import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getFooterData = async () => {
  const data = await fetchData(ENDPOINTS.GET.FOOTER, {
    method: METHODS.GET,
  });
  return data;
};
